import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=4d3f5b46&scoped=true"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=4d3f5b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f5b46",
  null
  
)

export default component.exports